import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBusRoute = ({ courseId, routeId, ...data }) => {
  return api.put(`admin/bus-courses-v2/${courseId}/routes/${routeId}`, data);
};

export const usePutBusRouteMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putBusRoute,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
